export default __webpack_public_path__ + "static/media/Foxmula.fce71671.png";